import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function NewLocatie() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');

  const [values, setValues] = useState({
    location_name: '',
    address: '',
    phone: '',
    email: '',
    contact_firstname: '',
    contact_lastname: '',
    contact_mobile: '',
  });

  const [emailExists, setEmailExists] = useState(false);

  const handleEmailBlur = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/check-email-existence`,
        {
          params: { email: values.email },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setEmailExists(response.data.exists);
    } catch (error) {
      console.error('Error checking email existence:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (emailExists) {
      alert('Het e-mailadres bestaat al in het systeem.');
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/location/addLocation`,
        values,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      navigate('/locaties');
    } catch (err) {
      console.error('Fout bij toevoegen locatie:', err);
    }
  };

  const handleCancel = () => {
    navigate('/locaties');
  };

  return (
    <div className="bg-white p-4">
      <h2 className="text-center">Nieuwe Locatie</h2>
      <hr className="seperator" />

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>
            Naam Locatie <span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control rounded-0"
            required
            value={values.location_name}
            onChange={(e) => setValues({ ...values, location_name: e.target.value })}
          />
        </div>

        <div className="row">
          <div className="mb-3 col">
            <label>
              Voornaam Contactpersoon<span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="text"
              className="form-control rounded-0"
              required
              value={values.contact_firstname}
              onChange={(e) =>
                setValues({ ...values, contact_firstname: e.target.value })
              }
            />
          </div>

          <div className="mb-3 col">
            <label>
              Achternaam Contactpersoon<span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="text"
              className="form-control rounded-0"
              required
              value={values.contact_lastname}
              onChange={(e) =>
                setValues({ ...values, contact_lastname: e.target.value })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="mb-3 col">
            <label>
              Email <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="email"
              className="form-control rounded-0"
              name="email"
              required
              value={values.email}
              onFocus={() => setEmailExists(false)}
              onChange={(e) => setValues({ ...values, email: e.target.value })}
              onBlur={handleEmailBlur}
            />
            {emailExists && (
              <div style={{ color: 'red' }}>Dit e-mailadres is al in gebruik.</div>
            )}
          </div>

          <div className="mb-3 col">
            <label>Mobiel Contactpersoon</label>
            <input
              type="text"
              className="form-control rounded-0"
              value={values.contact_mobile}
              onChange={(e) =>
                setValues({ ...values, contact_mobile: e.target.value })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="mb-3 col">
            <label>Telefoonnummer Locatie</label>
            <input
              type="text"
              className="form-control rounded-0"
              value={values.phone}
              onChange={(e) => setValues({ ...values, phone: e.target.value })}
            />
          </div>
        </div>

        <div className="row">
          <div className="mb-3 col">
            <label>Volledige Adres</label>
            <input
              type="text"
              className="form-control rounded-0"
              value={values.address}
              onChange={(e) => setValues({ ...values, address: e.target.value })}
            />
          </div>
        </div>

        <hr className="seperator" />

        <div className="row">
          <div className="col-md-6">
            <button
              type="button"
              className="btn btn-secondary w-100 rounded-0"
              onClick={handleCancel}
            >
              Annuleren
            </button>
          </div>

          <div className="col-md-6">
            <button type="submit" className="btn btn-secondary w-100 rounded-0">
              Opslaan
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default NewLocatie;